import BulletIcon from './component.jsx'
export default BulletIcon
